var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 46,
    viewBox: "0 0 31 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65358 45.5C11.7936 45.5 15.1535 42.1401 15.1535 38.0001V30.5H7.65358C3.51358 30.5 0.153564 33.86 0.153564 38.0001C0.153564 42.1401 3.51358 45.5 7.65358 45.5Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.153564 23C0.153564 18.86 3.51358 15.5 7.65358 15.5H15.1535V30.4999H7.65358C3.51358 30.4999 0.153564 27.14 0.153564 23Z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.153564 8.00001C0.153564 3.86 3.51358 0.5 7.65358 0.5H15.1535V15.5H7.65358C3.51358 15.5 0.153564 12.14 0.153564 8.00001Z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1531 0.5H22.6531C26.7931 0.5 30.1531 3.86 30.1531 8.00001C30.1531 12.14 26.7931 15.5 22.6531 15.5H15.1531V0.5Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1531 23C30.1531 27.14 26.7931 30.4999 22.6531 30.4999C18.5131 30.4999 15.1531 27.14 15.1531 23C15.1531 18.86 18.5131 15.5 22.6531 15.5C26.7931 15.5 30.1531 18.86 30.1531 23Z",
    fill: "#1ABCFE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.3b8acce8708c830f778b505dd7f628e5.svg";
export { ForwardRef as ReactComponent };